'use strict';

var Fuse = require('fuse.js');
var Mark = require('mark.js');
var Utils = require('../../utils/utils');

var DropdownSearch = function(config) {

  var self = this;
  var $dropdown = config.dropdown;
  var $list = config.dropdownList;
  var $listItem = config.dropdownItem;
  var $input = config.dropdownInput;
  var $content = config.dropdownContent;
  var $itemTemplate = config.dropdownItemTemplate;
  var fuseOpts = {
    include: ['matches'],
    shouldSort: true,
    threshold: 0.6,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      'text'
    ]
  };
  var markOpts = {
    element: 'span'
  };

  self.parseDropdowns = function() {
    $dropdown.each(function() {
      var $this = $(this);

      if ($this.hasClass('-enable-search')) {
        var _$list = $this.find($list);
        var _$defaultItem = $this.find($listItem);
        var _$input = $this.find($input);
        var content = JSON.parse($this.find($content).html());
        var itemTemplate = $this.find($itemTemplate).html();

        self.initSearch(_$list, _$defaultItem, _$input, content, itemTemplate);
      }
    });
  }

  self.initSearch = function(_$list, _$defaultItem, _$input, content, itemTemplate) {

    var fuse = new Fuse(content, fuseOpts);

    _$input.on('keyup.dropdownSearch', new Utils().throttle(function() {
      var $this = $(this);
      var value = $this.val();
      var results = fuse.search(value);

      if (value === '') {
        self.removeResultItems(_$list);
        self.showDefaultItems(_$defaultItem);
      } else {
        self.removeResultItems(_$list);
        self.hideDefaultItems(_$defaultItem);
        self.showResults(_$list, itemTemplate, results)
      }
    }, 300));
  }

  self.showResults = function(_$list, itemTemplate, results) {

    var resultItem = _.template(itemTemplate);
    var appendItem = function(result) {
      _$list.append(resultItem({item: result.item}));
    };
    var $currentResultItem = _$list.find($('.is-dropdown-search-item'));

    results.forEach(function(result) {

      if (! $currentResultItem.length) {
        appendItem(result);
        self.highlightResultText(_$list, result);
      }
    });
  }

  self.highlightResultText = function(_$list, result) {
    var _$resultItem = _$list.find($('.is-dropdown-search-item'));

    _$resultItem.each(function() {
      var $this = $(this);
      var _$link = $this.find('a');
      var text = _$link.text();

      result.matches.forEach(function(match) {

        match.indices.forEach(function(indices) {
          var highlight = text.substring(indices[0], indices[1] + 1);
          var markInstance = new Mark($this[0]);
          markInstance.mark(highlight, markOpts);
        });
      });
    });
  }

  self.hideDefaultItems = function(_$defaultItem) {
    _$defaultItem.not('is-search-item').hide();
  }

  self.showDefaultItems = function(_$defaultItem) {
    _$defaultItem.not('is-search-item').show();
  }

  self.removeResultItems = function(_$list) {
    var _$resultItem = _$list.find($('.is-dropdown-search-item'));
    _$resultItem.remove();
  }

  self.init = function() {
    self.parseDropdowns();
  }
};

module.exports = DropdownSearch;
